import EventBus from './Event/index.js';
import Modal from './Modal.js';
import { presGetFields, presSaveFields } from './api_client/api_prescreening.js';
import { validators, onMoneyValueChange } from './utils/utils-form.js';

class Prescreening {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$inputs = this.$el.find('input, select, textarea');
    this.$actionSaveStep = this.$el.find('[data-form-action="save"]');
    this.$actionNextStep = this.$el.find('[data-form-action="next"]');
    this.$actionPrevStep = this.$el.find('[data-form-action="prev"]');
    this.$actionSubmit = this.$el.find('[data-form-action="submit"]');
    // Elements in parent modal
    this.$modal = this.$el.closest('[data-modal="root"]');
    this.$startPrescreening = this.$modal.find('[data-modal-trigger="prescreening"]');
    this.modalName = this.$modal.data('modal-name');

    this.formStep = 1;

    this.moneyFieldsSelectors = [
      '[name="pres_monthly_housing_budget"]',
    ];
    
    this.inputsState = {};
    this.initInputsState();

    Modal.showInnerSection(this.modalName, 'start');

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  // set initial state of inputs
  initInputsState() {
    // set money fields to text type
    this.$inputs.filter(this.moneyFieldsSelectors.join(', ')).attr('type', 'text');
    // update earliest move date field min to today
    const $earliestMoveDate = this.$inputs.filter('[name="pres_earliest_move_date"]');
    $earliestMoveDate.attr('min', new Date().toISOString().split('T')[0]);

    this.$inputs.each((i, input) => {
      const $input = $(input);
      const name = $input.attr('name');
      this.inputsState[name] = $input.val();
    });
  }

  // clear all inputs
  clearInputs() {
    this.$inputs.each((i, input) => {
      const $input = $(input);
      $input.val('');
    });
    this.initInputsState();
  }

  // clear all inputs
  clearInputs() {
    this.$inputs.each((i, input) => {
      const $input = $(input);
      $input.val('');
    });
    this.initInputsState();
  }

  // update inputs state
  updateInputsState(fieldName, value) {
    this.inputsState[fieldName] = value;
    if (value !== this.$inputs.filter(`[name="${fieldName}"]`).val()) {
      this.$inputs.filter(`[name="${fieldName}"]`).val(value);
    }

    // format money fields
    if (this.moneyFieldsSelectors.includes(`[name="${fieldName}"]`)
    || this.moneyFieldsSelectors.includes(`[name^="${fieldName.slice(0, -1)}"]`)) {
      const $field = this.$inputs.filter(`[name="${fieldName}"]`);
      $field.attr('type', 'text');
      onMoneyValueChange($field);
    }
  }

  bindEvents() {
    this.$inputs.on('change', this.onInputChange.bind(this));
    this.$actionSaveStep.on('click', this.onSaveUserFields.bind(this));
    this.$el.on('submit', this.onFormSubmit.bind(this));
    this.$startPrescreening.on('click', () => {
      Modal.showInnerSection(this.modalName, 'prescreening');
    });
    this.$el.on('blur', this.moneyFieldsSelectors.join(', '), this.onBlurMoneyField.bind(this));

    EventBus.on('user:loaded', this.getUserPresFields.bind(this));
    EventBus.on('user:empty', this.onUserEmpty.bind(this));

    EventBus.on('form-steps:navigate', this.onFormStepNavigate.bind(this));
    EventBus.on('form-steps:before-navigate', this.onBeforeNavigate.bind(this));
  }

  onInputChange(e) {
    const $input = $(e.target);
    const name = $input.attr('name');
    const value = $input.val();

    this.updateInputsState(name, value);
  }

  async getUserPresFields() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    const pres_owner_user = window.grapp.user.auth.email;
    this.updateInputsState('pres_owner_user', pres_owner_user);
    try {
      const userFieldsRes = await presGetFields(pres_owner_user);
      
      if (userFieldsRes.fields) {
        const userFields = userFieldsRes.fields;
        this.$inputs.each((i, input) => {
          const $input = $(input);
          const name = $input.attr('name');
          if (userFields[name]) {
            this.updateInputsState(name, userFields[name]);
          }
        });
      }
    } catch(err) {
      console.log('Error getting user pres fields: ', err);
    }
  }

  async onSaveUserFields() {
    const errors = this.validateFields();
    if (errors.length > 0) {
      return;
    };

    try {
      const saveRequest = await presSaveFields(this.inputsState);
      if (saveRequest) {
        EventBus.emit('toast', {type: 'success', message: 'Saved!'});
        console.log('user fields saved successfully', saveRequest);
        return { success: true };
      } else {
        EventBus.emit('toast', {type: 'error', message: 'Failed to save. Please try again.'});
        return { success: false, saveRequest };
        // throw new Error('Save failed');
      }
    } catch(err) {
      EventBus.emit('toast', {type: 'error', message: 'Save failed. Please try again.'});
      console.log('Error saving user pres fields: ', err);
    }
  }

  getValidationErrors() {
    validators.minDate.message = 'Date must be greater than today';
    validators.maxDate.message = 'Date must be less than or equal to 01-01-2050';

    const fieldsToValidate = {
      '1': [
        { name: 'pres_metro_area', validators: [validators.required] },
      ],

      '2': [
        { name: 'pres_earliest_move_date', validators: [validators.required, validators.minDate, validators.maxDate] },
      ],

      '3': [
        { name: 'pres_monthly_housing_budget', validators: [validators.required] },
      ],

      '4': [
        { name: 'pres_credit_score_range', validators: [validators.required] },
      ],
    };

    const stepFields = fieldsToValidate[this.formStep];
    const errors = [];
    stepFields.forEach(field => {
      const $input = this.$inputs.filter(`[name="${field.name}"]`);
      const value = $input.val();
      field.validators.forEach(validator => {
        // different case for date fields
        if (field.name === 'pres_earliest_move_date') {
          const dateToCompare = validator === validators.minDate ? $input.attr('min') : $input.attr('max');
          if (!validator.validate(value, dateToCompare)) {
            errors.push({ name: field.name, message: validator.message });
          }
        } else {
          if (!validator.validate(value)) {
            errors.push({ name: field.name, message: validator.message });
          }
        } 
      });
    });

    return errors;
  }

  validateFields() {
    let errors = this.getValidationErrors();

    if (errors.length) {
      errors.forEach(error => {
        const $field = this.$inputs.filter(`[name="${error.name}"]`);
        const $parent = $field.parent();

        if ($field.hasClass('form_error_field')) {
          return;
        }
  
        $field.addClass('form_error_field');
        if ($parent.find(`[data-msg="${error.message}"]`).length === 0) {
          const $message = $(`<div class="form_error_message" data-msg="${error.message}">${error.message}</div>`);
          $field.before($message);
        }
        // scroll to first error
        if (errors.indexOf(error) === 0) {
          $('html, body').animate({
            scrollTop: $field.offset().top - 100,
          }, 500);
        }
      });

    } else {
      this.$inputs.removeClass('form_error_field');
      this.$el.find('.form_error_message').remove();
      errors = [];
    }

    return errors;
  }

  onBeforeNavigate() {
    const errors = this.validateFields();
    EventBus.emit('form-steps:validation', errors.length === 0);
  }

  onFormStepNavigate(payload) {
    this.formStep = payload.step;
  }

  async onFormSubmit(e) {
    // e.preventDefault();
    // console.log('form submitted');
    // Modal.showInnerSection(this.modalName, 'calendar');
    // Modal.close('prescreening');
    const savePres = await this.onSaveUserFields();
    if (savePres.success) {
      EventBus.emit('toast', {type: 'success', message: 'Prescreening submitted!'});
      EventBus.emit('prescreening:submitted');
    }
  }

  onBlurMoneyField(e) {
    const $input = $(e.target);
    $input.attr('type', 'text');
    onMoneyValueChange($input);

    this.updateInputsState($input.attr('name'), $input.val());
  }

  // @TODO: implement handler for no user found
  onUserEmpty() {
    console.log('User is empty');
  }

  static init() {
    $('[data-js-form="prescreening"]').each((i, el) => new Prescreening(el));
  }
}

Prescreening.init();
